import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Status',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
